module.exports = __webpack_public_path__ + "img/amazoneks.08036fe5.svg";